import { useCallback, useEffect, useRef, useState } from 'react'
import LoadingSpinner from '../../../../../baseComponents/LoaderDecider/LoadingSpinner'
import { RectangularInputSmall } from '../../../../../forms/Input'
import { twinFetchPostJSON } from '../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../utils/globals/dictionary'
import SearchBarProductResults from '../../../../Product/SearchBarProduct/SearchBarProductResults'
import useOnClickOutside from '../../../../../utils/hooks/useOnClickOut'
import { OnChangeOrderAddProduct, OrderSearchProductFieldType, OrderSearchProductInputChangeSearchFunc } from '../../OrderLayout/OrderTable/TableComponents/Inputs/OrderSearchProductInput/types'
import { useDebounce } from 'use-debounce'
import { ProductExtendedTyShort } from '../../../../Product/types'
import { ITLayoutTableModalOpenSetTy } from '../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { RowData } from '../../../../../baseComponents/TwinTable/types'
import useIsLoading from '../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import TwinTrans from '../../../../../baseComponents/TwinTrans'
import { CustomCreateProductCustomSelectSection, DisplayProductDot, OrderSearchProductInputProps } from '../../OrderLayout/OrderTable/TableComponents/Inputs/OrderSearchProductInput'


export interface OrderSearchSupplierProductInputProps extends OrderSearchProductInputProps {
    SupplierId: number
    findFirstNameColumn?: boolean
}

export const OrderSearchSupplierProductInputReference: React.FC<OrderSearchSupplierProductInputProps> = ({ allRowData, field, setOpenModal, onChange, SupplierId, findFirstNameColumn }) => {
    const { searchValue, changeSearchValue, listProducts, onSelectProduct, onFocus, ref, handleOnKeyDown, loading } = useOrderSearchSupplierProductInputLogic({ field, onChange, allRowData, setOpenModal, SupplierId })
    if (allRowData.ProductId) {
        if (field === 'reference' && allRowData['Product.uniqueProduct']) {
            return <DisplayProductDot findFirstNameColumn={findFirstNameColumn} allRowData={allRowData}><div className='twin_elipsis_table_two_lines'>{allRowData['unique_number']}</div></DisplayProductDot>
        }
        return <DisplayProductDot findFirstNameColumn={findFirstNameColumn} allRowData={allRowData}><div className='twin_elipsis_table_two_lines'>{allRowData[field]}</div></DisplayProductDot>
    }
    if (loading) {
        return <div className='w-full'><LoadingSpinner className='w-20 h-20 mx-auto' /></div>
    }
    return (
        <div className='relative input_table_searchproductinput' ref={ref}>
            <RectangularInputSmall onChange={changeSearchValue} onKeyDown={handleOnKeyDown} value={searchValue} onFocus={onFocus} />
            <SearchBarProductResults products={listProducts} {...{ onSelectProduct, allRowData, field }} />
        </div>
    )
}

export const OrderSearchSupplierProductInputName: React.FC<OrderSearchSupplierProductInputProps> = ({ allRowData, field, setOpenModal, onChange, SupplierId, findFirstNameColumn }) => {
    const { searchValue, changeSearchValue, listProducts, onSelectProduct, onFocus, ref, handleOnKeyDown, loading } = useOrderSearchSupplierProductInputLogic({ field, onChange, allRowData, setOpenModal, SupplierId })
    const { t } = useTwinTranslation()
    if (allRowData.ProductId) {
        let extraMessage = allRowData.packQuantity && parseFloat(allRowData.packQuantity) !== 1 ? (' - ' + t('pack', 'Pack') + ' ' + allRowData.packQuantity) : ''
        if (allRowData['Product.active']) {
            return <DisplayProductDot findFirstNameColumn={findFirstNameColumn} allRowData={allRowData}><div className='twin_elipsis_table_two_lines'>{allRowData[field]}{extraMessage}</div></DisplayProductDot>
        }
        return <DisplayProductDot findFirstNameColumn={findFirstNameColumn} allRowData={allRowData}><div className='twin_elipsis_table_two_lines'>{allRowData[field]}{extraMessage} <span className='italic'>(<TwinTrans transKey={'deleted'}>Eliminado</TwinTrans>)</span></div></DisplayProductDot>
    }
    if (loading) {
        return <div className='w-full'><LoadingSpinner className='w-20 h-20 mx-auto' /></div>
    }
    return (
        <div className='relative input_table_searchproductinput' ref={ref}>
            <RectangularInputSmall onChange={changeSearchValue} onKeyDown={handleOnKeyDown} value={searchValue} onFocus={onFocus} />
            <SearchBarProductResults products={listProducts} {...{ onSelectProduct, field }} />
        </div>
    )
}

export const OrderSearchSupplierProductInputReferenceAndName: React.FC<OrderSearchSupplierProductInputProps> = ({ allRowData, field, setOpenModal, onChange, SupplierId, findFirstNameColumn }) => {
    const { searchValue, changeSearchValue, listProducts, onSelectProduct, onFocus, ref, handleOnKeyDown, loading } = useOrderSearchSupplierProductInputLogic({ field, onChange, allRowData, setOpenModal, SupplierId })
    const { t } = useTwinTranslation()
    if (allRowData.ProductId) {
        if (field === 'reference' && allRowData['Product.uniqueProduct']) {
            return <DisplayProductDot findFirstNameColumn={findFirstNameColumn} allRowData={allRowData}><div className='twin_elipsis_table_two_lines'>{allRowData['unique_number']}</div></DisplayProductDot>
        }
        let extraMessage = allRowData.packQuantity && parseFloat(allRowData.packQuantity) !== 1 ? (' - ' + t('pack', 'Pack') + ' ' + allRowData.packQuantity) : ''
        if (allRowData['Product.active']) {
            return <DisplayProductDot findFirstNameColumn={findFirstNameColumn} allRowData={allRowData}><div className='twin_elipsis_table_two_lines'>{allRowData.reference} - {allRowData.name}{extraMessage}</div></DisplayProductDot>
        }
        return <DisplayProductDot findFirstNameColumn={findFirstNameColumn} allRowData={allRowData}><div className='twin_elipsis_table_two_lines'>{allRowData[field]}{extraMessage} <span className='italic'>(<TwinTrans transKey={'deleted'}>Eliminado</TwinTrans>)</span></div></DisplayProductDot>
    }
    if (loading) {
        return <div className='w-full'><LoadingSpinner className='w-20 h-20 mx-auto' /></div>
    }
    return (
        <div className='relative input_table_searchproductinput' ref={ref}>
            <RectangularInputSmall onChange={changeSearchValue} onKeyDown={handleOnKeyDown} value={searchValue} onFocus={onFocus} />
            <SearchBarProductResults products={listProducts} {...{ onSelectProduct, allRowData, field }} />
            {(searchValue === '' && !listProducts?.length) ? <CustomCreateProductCustomSelectSection onSelectProduct={onSelectProduct} products={listProducts} setOpenModal={setOpenModal} /> : null}
        </div>
    )
}

interface OrderSearchSupplierProductInputLogicProps {
    SupplierId: number
    field: OrderSearchProductFieldType
    allRowData: RowData
    onChange: OnChangeOrderAddProduct
    setOpenModal: ITLayoutTableModalOpenSetTy
}

const useOrderSearchSupplierProductInputLogic = ({ SupplierId, field, onChange, allRowData, setOpenModal }: OrderSearchSupplierProductInputLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()
    const [listProducts, setListProducts] = useState<ProductExtendedTyShort[] | null>(null)
    const [searchValue, setSearchValue] = useState<string>('')
    const [debounceValue] = useDebounce(searchValue, 200)
    const ref = useRef<any>(null)

    const changeSearchValue: OrderSearchProductInputChangeSearchFunc = useCallback((myvalue) => {
        setSearchValue(myvalue)
    }, [setSearchValue])

    const onFocus = useCallback(() => {
        setListProducts([])
    }, [])

    const onBlur = useCallback(() => {
        setSearchValue('')
        setListProducts(null)
    }, [])

    const onSelectProduct: OnChangeOrderAddProduct = useCallback((product) => {
        startLoading()
        if (product.isVariantProduct && !product.ProductId) {
            setOpenModal({ type: 'complexProduct', allRowData: { ...product } })
            onBlur()
            endLoading()
        } else {
            onChange({ ...product })
        }
    }, [onChange, setOpenModal, onBlur, startLoading, endLoading])

    const handleOnKeyDown = useCallback((event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            if (listProducts && listProducts.length) {
                onSelectProduct(listProducts[0])
            }
        }
    }, [onSelectProduct, listProducts])

    const openModalCreateProduct = useCallback(() => {
        onBlur()
        setOpenModal({ type: 'createProduct', allRowData })
    }, [onBlur, setOpenModal, allRowData])

    useOnClickOutside(ref, onBlur)

    const getAllProducts = useCallback(async (mySearchValue: string) => {
        const extraWhere: TwinDictionary = {}
        const myiLike = {
            $iLike: '%' + mySearchValue + '%',
        }
        if (field === 'referenceAndName') {
            extraWhere['$or'] = [
                {
                    '$or': [
                        { name: myiLike },
                        { reference: myiLike },
                        { code_bar: myiLike },
                        { supplier_reference: myiLike },
                    ],
                    uniqueProduct: false,
                    'Product.ProductId': {
                        '$is': null
                    }
                },
                {
                    unique_number: mySearchValue,
                    uniqueProduct: true
                },
                {
                    '$or': [
                        { name: mySearchValue },
                        { reference: mySearchValue },
                        { code_bar: mySearchValue },
                        { supplier_reference: mySearchValue },
                    ],
                    uniqueProduct: false,
                    'Product.ProductId': {
                        '$not': null
                    }
                },
            ]
        } else if (field === 'reference'){
            extraWhere['$or'] = [
                {
                    '$or': [
                        { reference: myiLike },
                        { supplier_reference: myiLike },
                    ],
                    uniqueProduct: false,
                    'Product.ProductId': {
                        '$is': null
                    }
                },
                {
                    '$or': [
                        { reference: mySearchValue },
                        { supplier_reference: mySearchValue },
                    ],
                    uniqueProduct: false,
                    'Product.ProductId': {
                        '$not': null
                    }
                },
            ]
        } else {
            extraWhere['$or'] = [
                {
                    [field]: myiLike,
                    uniqueProduct: false,
                    'Product.ProductId': {
                        '$is': null
                    }
                },
                {
                    [field]: mySearchValue,
                    uniqueProduct: false,
                    'Product.ProductId': {
                        '$not': null
                    }
                },
            ]
        }

        extraWhere['SupplierId'] = SupplierId
        const result = await twinFetchPostJSON('/api/app/product/getAllProductsForBuyOrder', {
            where: {
                productType: {
                    $notIn: [5]
                },
                ...extraWhere
            },
            limit: 15
        })
        setListProducts(result)
    }, [field, SupplierId])

    useEffect(() => {
        if (debounceValue !== '') {
            getAllProducts(debounceValue)
        } else if (debounceValue === '') {
            setListProducts((old) => {
                if (old) {
                    return []
                }
                return null
            })
        }
    }, [debounceValue, getAllProducts, SupplierId])

    return { searchValue, changeSearchValue, listProducts, onSelectProduct, onFocus, ref, openModalCreateProduct, handleOnKeyDown, loading }
}